import { render } from "./LogArticleList.vue?vue&type=template&id=8a87b398"
import script from "./LogArticleList.vue?vue&type=script&lang=js"
export * from "./LogArticleList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__